import {EventTypeNewsroom} from '../entities/event-type/event-type-document.interface';

export class NewsroomHelper {
  public static init(publicToken = '', wallChannelId = ''): EventTypeNewsroom {
    return {publicToken, wallChannelId};
  }
}
